import { render, staticRenderFns } from "./MedecinDetailContratcreate.vue?vue&type=template&id=3fa6a5aa&"
import script from "./MedecinDetailContratcreate.vue?vue&type=script&lang=js&"
export * from "./MedecinDetailContratcreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports